import { render } from "./LikesList.vue?vue&type=template&id=6ce9d519&scoped=true"
import script from "./LikesList.vue?vue&type=script&lang=js"
export * from "./LikesList.vue?vue&type=script&lang=js"

import "./LikesList.vue?vue&type=style&index=0&id=6ce9d519&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce9d519"]])

export default __exports__